// document.addEventListener("DOMContentLoaded", function() {
//     const tooltips = document.querySelectorAll('.tooltip');

//     tooltips.forEach(tooltip => {
//         tooltip.addEventListener('mouseover', function() {
//             this.querySelector('.tooltip-text').style.visibility = 'visible';
//         });

//         tooltip.addEventListener('mouseout', function() {
//             this.querySelector('.tooltip-text').style.visibility = 'hidden';
//         });
//     });
// });

document.addEventListener("DOMContentLoaded", function() {
    var toggleHeaders = document.querySelectorAll('.toggle-header');
    toggleHeaders.forEach(function(header) {
        var contentInner = header.nextElementSibling;
        var chevronIcon = header.querySelector('.chevron-icon');

        if (contentInner && contentInner.classList.contains('content-inner')) {
            contentInner.classList.add('visible');
            chevronIcon.classList.add('rotated');
        }

        header.addEventListener('click', function() {
            if (contentInner.classList.contains('visible')) {
                contentInner.classList.remove('visible');
                chevronIcon.classList.remove('rotated');
            } else {
                contentInner.classList.add('visible');
                chevronIcon.classList.add('rotated');
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
    var expertParent = document.querySelector('.expert-parent');
    var expertBlocks = expertParent.querySelectorAll('.expert-block');

    var hasContent = Array.from(expertBlocks).some(function(block) {
        var title = block.querySelector('h2');
        var text = block.querySelector('.expert-text');
        var image = block.nextElementSibling && block.nextElementSibling.tagName === 'IMG';
        return title && text && image;
    });

    if (hasContent) {
        expertParent.classList.add('has-content');
    }
});


function showPopup(element) {
    var popup = element.closest('.info-icon-container').nextElementSibling;
    if (popup && popup.classList.contains('popup')) {
        popup.style.display = 'block';
    }

    var m6prElements = document.querySelectorAll('.m6pr');
    m6prElements.forEach(function(m6prElement) {
        m6prElement.classList.add('z-index-0');
    });

    var trElements = document.querySelectorAll('tr');
    trElements.forEach(function(trElement) {
        trElement.classList.add('z-index-0');
    });
}

function hidePopup(element) {
    var popup = element.closest('.popup');
    if (popup) {
        popup.style.display = 'none';
    }

    var m6prElements = document.querySelectorAll('.m6pr');
    m6prElements.forEach(function(m6prElement) {
        m6prElement.classList.remove('z-index-0');
    });

    var trElements = document.querySelectorAll('tr');
    trElements.forEach(function(trElement) {
        trElement.classList.remove('z-index-0');
    });
}

